export default (telephoneNr) => `tel:${telephoneNr.split("-").join("")}`;
